<template>
  <ul
    class='i-menu-list'
    :class="{[`imenu_level${level+1}`]: true}"
    @keydown.down.stop.prevent="focusNext"
    @keydown.up.stop.prevent="focusPrev"
    @keydown.left.stop.prevent="$emit('collapse')"
    @keydown.esc.stop.prevent="$emit('collapse')"
    v-show="expanded || hasFocus">
      <li v-for="(item, idx) in items" :key="item.label" :class="{'li-active': item.currentSubPage, 'li-has-children': item.children}">
        <MenuItem
            :item="item"
            :index="idx"
            :level="level"
            :parentIndex="parentIndex || 0"
            :focused="focusIndex == idx"
            @onItemFocus="focusIndex = idx"
            @onItemBlur="focusIndex = -1"
        />
      </li>
  </ul>
</template>

<script>
import { defineComponent } from 'vue';
import { clamp } from '@/utils/tools';
import MenuItem from './MenuItem.vue';

export default defineComponent({
  components: {
    MenuItem,
  },
  props: {
    level: {
      type: Number,
      default: 0,
    },
    items: {
      type: Array,
      default: () => [],
    },
    expanded: Boolean,
    settings: Object,
    parentIndex: Number,
  },
  data: () => ({
    focusIndex: -1,
  }),
  computed: {
    hasFocus() {
      return this.focusIndex !== -1;
    },
  },
  methods: {
    focusNext() {
      this.focusIndex = clamp(this.focusIndex + 1, 0, this.items.length - 1);
    },
    focusPrev() {
      this.focusIndex = clamp(this.focusIndex - 1, 0, this.items.length - 1);
    },
    open() {
      this.focusIndex = 0;
    },
  },
});

</script>

<style scoped lang='scss'>
  // fix: overwrite global CSS
  #imenu ul.imenu_level2 {
    display: block;
  }
</style>
